import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutThirdFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconLayoutThirdFull"><Path d="M4.5 3C3.67157 3 3 3.67157 3 4.5V8.25L21 8.25V4.5C21 3.67157 20.3284 3 19.5 3H4.5Z" fill="currentColor"/><Path d="M3 14.75V9.25L21 9.25V14.75L3 14.75Z" fill="currentColor"/><Path d="M3 15.75V19.5C3 20.3284 3.67157 21 4.5 21H19.5C20.3284 21 21 20.3284 21 19.5V15.75L3 15.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutThirdFull;
